import { PLANE_DEFAULT_Z } from '@Components/BigBrowse/BigBrowseConfig';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_Merchandiser>;
  children: ReactNode;
};

export const MerchandiserContent = observer(function MerchandiserContent({
  gridCard,
  children,
}: Props) {
  const internals = gridCard.data!.internals!;

  return (
    <mesh
      position={[
        internals.contentPosition.x,
        internals.contentPosition.y,
        PLANE_DEFAULT_Z,
      ]}
    >
      {children}
    </mesh>
  );
});
